import { Component, ContentChild, ContentChildren, EventEmitter, forwardRef, Input, Output, QueryList, TemplateRef } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { BaseViewComponent } from '@sb/library/base';
import { FormFieldCheckboxMultiSelectComponent } from '@sb/library/form-field';
import { ChipMultiSelectBottomSheetComponent } from './multi-select-bottom-sheet/chip-multi-select-bottom-sheet.component';

@Component({
    selector: 'lib-chip-button-multi-select',
    templateUrl: './chip-button-multi-select.component.html',
    styleUrl: './chip-button-multi-select.component.scss',
    viewProviders: [
        {
            provide: MAT_SELECT_CONFIG,
            useFactory: (component: ChipButtonMultiSelectComponent<any>) => ({
                overlayPanelClass:  ["v3", "scss-chip-select-panel"],
                panelWidth: component.panelWidth
            }),
            // need to inject MAT_SELECT_CONFIG here, and need to be able to access the input before its defined
            deps: [forwardRef(() => ChipButtonMultiSelectComponent)]
        }
    ]
})

export class ChipButtonMultiSelectComponent <T extends string> extends BaseViewComponent {
    @ContentChildren(FormFieldCheckboxMultiSelectComponent) groupItemQueryList!: QueryList<FormFieldCheckboxMultiSelectComponent<T>>;
    @ContentChild('bottomSheetTitle', { read: TemplateRef }) labelTemplate!: TemplateRef<any>;
    @ContentChild('triggerTemplate', {static: true}) triggerTemplate!: TemplateRef<any>;

    @Input() disableBottomSheet: boolean = false;
    @Input() stretch: boolean = false;
    @Input() currentSelection: T[] = [];
    @Input() panelWidth: string | number | null = 320;

    @Output() selectionChange: EventEmitter<Record<number, T[]>> = new EventEmitter();

    private _itemList: FormFieldCheckboxMultiSelectComponent<T>[] = [];
    private _currentSelectedItems: Record<number, T[]> = [];

    constructor(private _MatBottomSheet: MatBottomSheet) {
        super();
    }

    ngAfterViewInit(): void {
        this._itemList = this.groupItemQueryList.toArray();

        this._itemList.forEach((group, mapIndex) => {
            Object.values(group.indexMap).forEach((item, itemIndex) => {
                if (this.currentSelection.find(cbx => cbx == item)) {
                    this.ChangeEvent(group, mapIndex, true, itemIndex);
                }
            });
        });
    }


    SelectClicked(event: MouseEvent): void {
        if (this.isMobile && !this.disableBottomSheet) {
            event.stopPropagation(); // prevent dropdown from opening

            const bottomSheetRef = this._MatBottomSheet.open(ChipMultiSelectBottomSheetComponent, {
                data: {Options: this._itemList, CurrentSelected: this._currentSelectedItems, Label: this.labelTemplate},
                hasBackdrop: true,
                disableClose: true
            });

            bottomSheetRef.afterDismissed().subscribe((value: Record<number, T[]>) => {
                if (value) {
                    this._currentSelectedItems = value;
                    this.SelectClosed();
                }
            });
        }
    }

    SelectAll(item: FormFieldCheckboxMultiSelectComponent<T>, mapIndex: number, event: boolean): void {
        item.SelectAll(event);
        this.ChangeEvent(item, mapIndex, event);
    }

    ChangeEvent(item: FormFieldCheckboxMultiSelectComponent<T>, mapIndex: number, event: boolean, itemIndex: number | null = null): void {
        item.ChangeEvent(event, itemIndex);
        this._currentSelectedItems[mapIndex] = item.formControl.value;
    }

    SelectClosed(): void {
        this.selectionChange.emit(this._currentSelectedItems);
    }

    get itemList(): FormFieldCheckboxMultiSelectComponent<T>[] {
        return this._itemList;
    }
}
